import { colors } from '../constants';

export const elementClasses = {
  radio: 'flow-radio',
  paymentButton: 'payment-button',
};

const cssBlocks = {
  radio: `
    .${elementClasses.radio} input[type=radio] {
      position: absolute;
      top: 0;
      left: 0;
      width: 24px;
      height: 24px;
      cursor: pointer;
      opacity: 0;
      z-index: -1;
    }

    .${elementClasses.radio} label {
      padding: 16px 10px 16px 44px;
      user-select: none;
      line-height: 20px;
      cursor: pointer;
    }

    .${elementClasses.radio} label::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 10px;
      width: 24px;
      height: 24px;
      border: 2px solid #bfbfbf;
      background: #fff;
      border-radius: 50%;
      box-sizing: border-box;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }

    .${elementClasses.radio} label::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 16px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: ${colors.primaryBlue};
      box-sizing: border-box;
      opacity: 0;
      transition-property: opacity;
      transition-duration: .2s;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }

    .${elementClasses.radio} input[type=radio]:checked + label::after {
      opacity: 1;
    }
  `,
  paymentButton: `
  .${elementClasses.paymentButton} {
    border: 0;
    cursor: pointer;
    padding: 4px;
    min-width: 200px;
    display: inline-block;
    line-height: 1.75;
    font-size: 1em;
    background-color: ${colors.primaryBlue};
    color: #f2f5f9;
    border-radius: 4px;
  }

  .${elementClasses.paymentButton}:hover {
    background-color: ${colors.primaryBlueHover};
  }

  .${elementClasses.paymentButton}:active {
    background-color: ${colors.primaryBlue};
  }
  `,
};

export const commonCssId = 'flowCommonCss';

export default function injectCommonCss(blocks: (keyof typeof cssBlocks)[]): void {
  if (document.getElementById(commonCssId) !== null) {
    return;
  }
  const styleEl = document.createElement('style');
  styleEl.id = commonCssId;
  styleEl.setAttribute('data-blocks', blocks.join(' '));

  const cssText = document.createTextNode(blocks.map((block) => cssBlocks[block]).join('\n'));
  styleEl.appendChild(cssText);
  document.head.appendChild(styleEl);
}
